import { render, staticRenderFns } from "./PagePaperlessEnroll.vue?vue&type=template&id=28bf6046&scoped=true&"
import script from "./PagePaperlessEnroll.vue?vue&type=script&lang=js&"
export * from "./PagePaperlessEnroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bf6046",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28bf6046')) {
      api.createRecord('28bf6046', component.options)
    } else {
      api.reload('28bf6046', component.options)
    }
    module.hot.accept("./PagePaperlessEnroll.vue?vue&type=template&id=28bf6046&scoped=true&", function () {
      api.rerender('28bf6046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/paperlessenroll/PagePaperlessEnroll.vue"
export default component.exports